export const calculateDreamProgress = (dream) => {
  return Math.round((dream?.amountReceived * 100) / dream?.amount);
};
